export enum MessageType {
  MEDIA = 1,
  DOC = 2,
  TEXT = 3,
  CLICKABLE = 4,
  LINK = 5,
  EQUATION = 6,
  DISAPPEAR = 7,
}
